import { API_ENDPOINTS } from './endPoints';
import { queuedFetch } from '../utils/requestQueue';

export type SearchResponse = {
  items: SearchResponseItem[];
  total: number;
};
export type SearchResponseItem = {
  id: number;
  name: string;
  page: string;
  text: string;
  pageTitle: string;
  pagePath: string;
};

export default async function searchText({
  lang,
  val,
  limit,
  offset,
}: {
  lang: string;
  val: string;
  limit: number;
  offset: number;
}): Promise<SearchResponse | undefined> {
  try {
    const data = await queuedFetch(
      `${process.env.NEXT_PUBLIC_API_URL}${API_ENDPOINTS.SEARCH_URL}?q=${val}&limit=${limit}&offset=${offset}`,
      {
        method: 'GET',
        headers: {
          'X-Language': lang,
        },
      },
    );

    return data.json();
  } catch (e) {
    console.log(e);
  }
}
